export default __webpack_public_path__ + "static/media/cp_geo_ee.65f4a3d8.svg";